module.exports = __webpack_public_path__ + "static/media/lepes3.ce59c9da.png";